export const reportsTypesByRoutes = {
  "device-list": "deviceList",
  "device-diagnostics": "deviceDiagnostics",
  "device-events": "deviceEvents",
  "device-parameters": "deviceParameterList",
  "device-graph": "deviceGraph",
  "audit-trail": "auditTrail",
};

export const tableHeading = {
  deviceDiagnostics: [
    "eventUuid",
    "clo2Value",
    "mode",
    "temperature",
    "humidity",
    "barometricPressure",
    "cartridgeLevel",
    "generated",
    "shotSize",
    "sgp4x1voc",
    "sgp4x1nox",
    "sgp4x2voc",
    "sgp4x2nox",
    "sgp4x3voc",
    "sgp4x3nox",
    "sgp4x4voc",
    "sgp4x4nox",
    "target",
    "timeStamp",
  ],
  deviceParameterList: [
    "deviceName",
    "deviceUDI",
    "clo2Value",
    "mode",
    "cartridge",
    "temperature",
    "humidity",
    "barometricPressure",
    "timeStamp",
  ],
  diagnosticsHeadingForMultiDevice: [
    "deviceName",
    "deviceUDI",
    "deviceUUID",
    "thingName",
    "model",
    "eventUuid",
    "clo2Value",
    "mode",
    "temperature",
    "humidity",
    "barometricPressure",
    "cartridgeLevel",
    "generated",
    "shotSize",
    "sgp4x1voc",
    "sgp4x1nox",
    "sgp4x2voc",
    "sgp4x2nox",
    "sgp4x3voc",
    "sgp4x3nox",
    "sgp4x4voc",
    "sgp4x4nox",
    "target",
    "timeStamp",
  ],
  deviceGraph: [],
  auditTrail: [
    "user",
    "userActionType",
    "userAction",
    "userActionDescription",
    "deviceName",
    "deviceUDI",
    "timeStamp",
  ],
  auditTrailSite: [
    "user",
    "userActionType",
    "userAction",
    "userActionDescription",
    "site",
    "deviceName",
    "deviceUDI",
    "timeStamp",
  ],
};

export const sortList = {
  deviceDiagnostics: {
    timeStamp: "desc",
    mode: "",
    cartridgeLevel: "",
    clo2Value: "",
    shotSize: "",
    humidity: "",
    temperature: "",
    deviceName: "",
  },
  deviceParameterList: {
    deviceName: "",
    timeStamp: "desc",
  },
  deviceGraph: [],
  auditTrail: {
    timeStamp: "desc",
  },
};

export const reportTypeString = {
  deviceDiagnostics: "Device Diagnostics",
  deviceParameterList: "Device Parameter List",
  deviceGraph: "Device Graph",
  auditTrail: "Audit Trail",
};

/***Filters Section Start*/

const ppbFilter = [
  { name: "beyond150", id: "Beyond150PctOfTarget" },
  { name: "beyond130", id: "Beyond130PctOfTarget" },
  { name: "within30", id: "Within30PctOfTarget" },
  { name: "below70", id: "Below70PctOfTarget" },
];

const mode = [
  { name: "operational", id: "operational" },
  { name: "senseOnly", id: "senseOnly" },
  { name: "standby", id: "standby" },
  { name: "online", id: "online" },
];

const cartridgeLevel = [
  { name: "20AndAbove", id: "20AndAbove" },
  { name: "10_19", id: "10_19" },
  { name: "below10", id: "below10" },
];

export const reportFilter = {
  deviceDiagnostics: {
    clo2Value: ppbFilter,
    mode: mode,
    cartridgeLevel: cartridgeLevel,
  },
};

/***Filters Section Ends*/

export const columListDiagnosticts = [
  {
    key: "deviceName",
    label: "tableHeading.deviceDiagnostics.deviceName",
    val: "",
    clickCount: 0,
    deviceName: "",
    sort: true,
    singleDevice: false,
  },
  {
    key: "deviceUDI",
    deviceUDI: "",
    label: "tableHeading.deviceDiagnostics.deviceUDI",
    val: "",
    clickCount: 0,
    sort: false,
    singleDevice: false,
  },
  {
    key: "deviceUUID",
    label: "tableHeading.deviceDiagnostics.deviceUUID",
    val: "",
    clickCount: 0,
    sort: false,
    deviceUUID: "",
    singleDevice: false,
  },
  {
    key: "thingName",
    label: "tableHeading.deviceDiagnostics.thingName",
    thingName: "",
    val: "",
    clickCount: 0,
    sort: false,
    singleDevice: false,
  },
  {
    key: "model",
    label: "tableHeading.deviceDiagnostics.model",
    val: "",
    clickCount: 0,
    sort: false,
    singleDevice: false,
    model: "",
  },
  {
    key: "eventUuid",
    label: "tableHeading.deviceDiagnostics.eventUuid",
    val: "",
    clickCount: 0,
    sort: false,
    eventUuid: "",
    singleDevice: true,
  },
  {
    key: "clo2Value",
    label: "tableHeading.deviceDiagnostics.clo2Value",
    val: "",
    clickCount: 0,
    sort: true,
    singleDevice: true,
    clo2Value: "",
  },
  {
    key: "mode",
    mode: "",
    label: "tableHeading.deviceDiagnostics.mode",
    val: "",
    clickCount: 0,
    sort: true,
    singleDevice: true,
  },
  {
    temperature: "",
    key: "temperature",
    label: "tableHeading.deviceDiagnostics.temperature",
    val: "",
    clickCount: 0,
    sort: true,
    singleDevice: true,
  },
  {
    key: "humidity",
    label: "tableHeading.deviceDiagnostics.humidity",
    val: "",
    clickCount: 0,
    sort: true,
    singleDevice: true,
    humidity: "",
  },
  {
    key: "barometricPressure",
    label: "tableHeading.deviceDiagnostics.barometricPressure",
    val: "",
    barometricPressure: "",
    clickCount: 0,
    sort: false,
    singleDevice: true,
  },
  {
    cartridgeLevel: "",
    key: "cartridgeLevel",
    label: "tableHeading.deviceDiagnostics.cartridgeLevel",
    val: "",
    clickCount: 0,
    sort: true,
    singleDevice: true,
  },
  {
    key: "generated",
    label: "tableHeading.deviceDiagnostics.generated",
    val: "",
    clickCount: 0,
    sort: false,
    singleDevice: true,
    generated: "",
  },
  {
    key: "shotSize",
    shotSize: "",
    label: "tableHeading.deviceDiagnostics.shotSize",
    val: "",
    clickCount: 0,
    sort: true,
    singleDevice: true,
  },
  {
    key: "sgp4x1voc",
    label: "tableHeading.deviceDiagnostics.sgp4x1voc",
    val: "",
    clickCount: 0,
    sort: false,
    sgp4x1voc: "",
    singleDevice: true,
  },
  {
    key: "sgp4x1nox",
    label: "tableHeading.deviceDiagnostics.sgp4x1nox",
    val: "",
    clickCount: 0,
    sort: false,
    singleDevice: true,
    sgp4x1nox: "",
  },
  {
    sgp4x2voc: "",
    key: "sgp4x2voc",
    label: "tableHeading.deviceDiagnostics.sgp4x2voc",
    val: "",
    clickCount: 0,
    sort: false,
    singleDevice: true,
  },
  {
    key: "sgp4x2nox",
    sgp4x2nox: "",
    label: "tableHeading.deviceDiagnostics.sgp4x2nox",
    val: "",
    clickCount: 0,
    sort: false,
    singleDevice: true,
  },
  {
    key: "sgp4x3voc",
    label: "tableHeading.deviceDiagnostics.sgp4x3voc",
    val: "",
    clickCount: 0,
    sgp4x3voc: "",
    sort: false,
    singleDevice: true,
  },
  {
    key: "sgp4x3nox",
    label: "tableHeading.deviceDiagnostics.sgp4x3nox",
    val: "",
    clickCount: 0,
    sort: false,
    sgp4x3nox: "",
    singleDevice: true,
  },
  {
    key: "sgp4x4voc",
    label: "tableHeading.deviceDiagnostics.sgp4x4voc",
    val: "",
    clickCount: 0,
    sgp4x4voc: "",
    sort: false,
    singleDevice: true,
  },
  {
    key: "sgp4x4nox",
    sgp4x4nox: "",
    label: "tableHeading.deviceDiagnostics.sgp4x4nox",
    val: "",
    clickCount: 0,
    sort: false,
    singleDevice: true,
  },
  {
    key: "target",
    label: "tableHeading.deviceDiagnostics.target",
    val: "",
    clickCount: 0,
    target: "",
    sort: false,
    singleDevice: true,
  },
  {
    timeStamp: "",
    key: "timeStamp",
    label: "tableHeading.deviceDiagnostics.timeStamp",
    val: "desc",
    clickCount: 0,
    sort: true,
    singleDevice: true,
  },
];

export const columListParameter = [
  {
    key: "deviceName",
    deviceName: "",
    label: "tableHeading.deviceParameterList.deviceName",
    val: "",
    clickCount: 0,
    sort: true,
    singleDevice: false,
  },
  {
    key: "deviceUDI",
    label: "tableHeading.deviceParameterList.deviceUDI",
    deviceUDI: "",
    val: "",
    clickCount: 0,
    sort: false,
    singleDevice: false,
  },
  {
    clo2Value: "",
    key: "clo2Value",
    label: "tableHeading.deviceParameterList.clo2Value",
    val: "",
    clickCount: 0,
    sort: false,
    singleDevice: true,
  },
  {
    key: "mode",
    label: "tableHeading.deviceParameterList.mode",
    val: "",
    clickCount: 0,
    sort: false,
    mode: "",
    singleDevice: true,
  },
  {
    key: "cartridge",
    cartridge: "",
    label: "tableHeading.deviceParameterList.cartridge",
    val: "",
    clickCount: 0,
    sort: false,
    singleDevice: true,
  },
  {
    key: "temperature",
    label: "tableHeading.deviceParameterList.temperature",
    val: "",
    clickCount: 0,
    sort: false,
    singleDevice: true,
    temperature: "",
  },
  {
    humidity: "",
    key: "humidity",
    label: "tableHeading.deviceParameterList.humidity",
    val: "",
    clickCount: 0,
    sort: false,
    singleDevice: true,
  },
  {
    key: "barometricPressure",
    label: "tableHeading.deviceParameterList.barometricPressure",
    barometricPressure: "",
    val: "",
    clickCount: 0,
    sort: false,
    singleDevice: true,
  },
  {
    key: "timeStamp",
    label: "tableHeading.deviceParameterList.timeStamp",
    val: "desc",
    timeStamp: "",
    clickCount: 2,
    sort: true,
    singleDevice: true,
  },
];
